import type { CapabilityDecisionResponse } from 'src/queries/physicalCardManagement/physicalCardManagement.models'
import { isCardManagementActionAvailable } from 'src/queries/physicalCardManagement/physicalCardManagement.models'

import type { PhysicalCardLifecycleAvailability } from './physicalCardLifecycle.types'

export const unavailablePhysicalCardLifecycleAvailability: PhysicalCardLifecycleAvailability =
  {
    replace: false,
    lostOrStolen: false,
    reportFraud: false,
    cancel: false,
    freeze: false,
    unfreeze: false,
  }

export const getPhysicalCardLifecycleAvailability = (
  capabilities: CapabilityDecisionResponse[] | undefined,
  hasOrgAdminPermissions: boolean,
  canDestroyCard: boolean,
): PhysicalCardLifecycleAvailability => ({
  replace: isCardManagementActionAvailable(
    capabilities,
    'REPLACE_PHYSICAL_CARD',
  ),
  lostOrStolen: isCardManagementActionAvailable(
    capabilities,
    'REPLACE_LOST_OR_STOLEN_PHYSICAL_CARD',
  ),
  reportFraud: isCardManagementActionAvailable(
    capabilities,
    'REPORT_PHYSICAL_CARD_FRAUD',
  ),
  cancel:
    hasOrgAdminPermissions &&
    canDestroyCard &&
    isCardManagementActionAvailable(capabilities, 'CANCEL_PHYSICAL_CARD'),
  freeze: isCardManagementActionAvailable(capabilities, 'FREEZE_PHYSICAL_CARD'),
  unfreeze: isCardManagementActionAvailable(
    capabilities,
    'UNFREEZE_PHYSICAL_CARD',
  ),
})
